import React, {useEffect, useState, Fragment} from 'react';
import RNUFormService from "../../../../services/RNUFormService";
import NumberFormat from "react-number-format";


const Template1BObservation = (props) => {

    const rnuFormService = new RNUFormService()
    const [items, setItems]= useState([])
    const fetchData = rnuFormService.getData('observation')
    const [asSurface, setAsSurface] = useState()

    useEffect(()=>{
        (fetchData)?setItems(fetchData):null;
        (props.formtype === 'level2' ||  props.formtype === 'level1')?setAsSurface(true):setAsSurface(null);

    },[fetchData])

    const renderItem=(item, index)=>{
        return(
            <tr key={index}>
                <td colSpan={2} className={'text-left'} style={{"padding": "0", "paddingTop": "0.2cm"}}>
                    <div className={"ue-data-libelle1"}> {item.libelle_1}</div>
                    <div className={(asSurface)?'ue-data-description':'ue-data-long-description'} style={{"whiteSpace": "pre-warp"}}>{item.description}</div>
                        <table className={"ue-table-small"}>
                            <tbody>

                            {renderSubItem(item, index)}

                            </tbody>
                        </table>
                </td>
            </tr>
        );
    }

    const renderSubItem = (item,index)=>{
        return (
            <tr key={index} style={{"borderBottom":"1px solid #cccccc"}}>
                <td className={'text-left'} style={{"paddingLeft": "0cm"}}>
                    {
                        <span className={"ue-data-libelle2"}>{item.libelle_2}</span>
                    }
                </td>
                {(asSurface) ?
                    <Fragment>
                        <td className={'ue-col-surface'}>
                            <span><NumberFormat value={Math.round(item.surface)} displayType={'text'}
                                                thousandSeparator={' '}/>m<sup>2</sup> </span>
                        </td>
                        <td className={'ue-col-percent'}>
                            <span>({Math.round(item.pourcentage * 10) / 10}%)</span>
                        </td>
                    </Fragment>
                    : null
                }
            </tr>
        )
    };

    return (
                <>

                {
                    (items.length>0)?
                    items.map((item, index) => {
                        (!item.description)?item.description='':null;
                        return (renderItem(item, index))
                    })
                    :null
                }
                </>

    );
};

export default Template1BObservation;
